export interface CompanyPlatformHeroMotion {
  progress: number;
  copyExit: number;
  zoom: number;
  demoInteractive: boolean;
}
const clamp01 = (value: number) => Math.max(0, Math.min(1, Number.isFinite(value) ? value : 0));

export const resolveCompanyPlatformHeroMotion = (value: number): CompanyPlatformHeroMotion => {
  const progress = clamp01(value);
  const time = clamp01(progress / 0.82);
  const zoom = time * time * (3 - 2 * time);
  return { progress, copyExit: clamp01((progress - 0.08) / 0.32), zoom, demoInteractive: time === 1 };
};
